module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1058.d44e7c88.png";